module.exports = __webpack_public_path__ + "img/scan-harness.4153682b.jpg";